import { AccessorsMutatorsDecorator, Model } from '../../helpers/model';
import { iotaGenerator } from '../../helpers/iota';

export class AccountCancellation extends Model {

    static get REASONS() {

        const iotaBinaryRadix = iotaGenerator(i => 1 << i);

        return [
            {label: 'I_WILL_NO_LONGER_BE_MANAGING_THE_PROPERTY', value: iotaBinaryRadix()},
            {label: 'I_WAS_NOT_HAPPY_WITH_THE_SUPPORT_PROVIDED', value: iotaBinaryRadix()},
            {label: 'PRICE_IS_TOO_HIGH', value: iotaBinaryRadix()},
            {label: 'PROPERTY_IS_NOT_OPEN_YET_BUT_I_INTEND_TO_USE_MABEET_WHEN_THE_PROPERTY_OPENS', value: iotaBinaryRadix()},
            {label: 'UNABLE_TO_USE_APPLICATION_DUE_TO_BAD_INTERNET', value: iotaBinaryRadix()},
            {label: 'MY_PROPERTY_IS_CLOSING_PERMANENTLY', value: iotaBinaryRadix()},
            {label: 'APPLICATION_IS_SLOW_AND_OR_HAS_BUGS', value: iotaBinaryRadix()},
            {label: 'APPLICATION_IS_DIFFICULT_TO_USE', value: iotaBinaryRadix()},
            {label: 'TOOK_TOO_LONG_TO_SETUP_IMPLEMENT_MY_PROPERTY', value: iotaBinaryRadix()},
            {label: 'I_DONT_KNOW_HOW_TO_USE_THE_APPLICATION', value: iotaBinaryRadix()},
            {label: 'I_DONT_NEED_THIS_TYPE_OF_APPLICATION', value: iotaBinaryRadix()},
            {label: 'I_HAD_PAYMENT_PROBLEMS_WITH_MY_MABEET_ACCOUNT', value: iotaBinaryRadix()},
            {label: 'APPLICATION_IS_MISSING_FUNCTIONALITY_INTEGRATIONS', value: iotaBinaryRadix()},
            {label: 'PROPERTY_IS_TEMPORARILY_CLOSING', value: iotaBinaryRadix()},
        ];
    }
}

AccessorsMutatorsDecorator(
    'property_id',
    'reasons',
    'comment',
    'will_use_another_provider',
    'recommendation_rate',
)
(AccountCancellation);



// WEBPACK FOOTER //
// ./src/pms-api/models/account-cancellation.model.js